import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Smartphone } from "lucide-react";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

// Lot 633 — interrupteur « Conseil temporaire app 2.1 » : le message « numéro trop court » de l'ancienne app porte un conseil pour
// les numéros commençant par 0 (+242 / +225 / +229 / +241). À masquer une fois la 2.2 adoptée.
export const PhoneZeroHintCard = () => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/settings/phone-zero-hint").then(({ data }) => setSt(data)).catch(() => {}); }, []);
  const toggle = async (v) => {
    setBusy(true);
    try {
      const { data } = await api.patch("/admin/settings/phone-zero-hint", { enabled: !!v });
      setSt((s) => ({ ...s, enabled: data.enabled, current_fr: data.current_fr }));
      toast.success(data.enabled ? "Conseil temporaire réaffiché dans l'app 2.1" : "Conseil temporaire masqué — message « trop court » standard");
    } catch (e) { toast.error(e?.friendlyMessage || "Erreur"); }
    finally { setBusy(false); }
  };
  if (!st) return null;
  return (
    <div className="rounded-xl px-4 py-3 mb-3" style={{ background: "var(--yalola-surface-alt)", border: "1px solid var(--yalola-border)" }} data-testid="settings-phone-zero-hint-row" data-enabled={st.enabled ? 1 : 0}>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="text-sm font-semibold flex items-center gap-1.5"><Smartphone size={14} /> Conseil temporaire app 2.1 (numéros commençant par 0)</div>
          <div className="text-[11px]" style={{ color: "var(--yalola-text-muted)" }}>
            L'app 2.1 retire à tort le 0 des numéros du Congo-Brazzaville, de Côte d'Ivoire, du Bénin et du Gabon. Tant que l'interrupteur est activé, son message « trop court »
            conseille de se connecter par e-mail ou sur yalola.app. Masque-le quand la 2.2 sera adoptée (le web et la 2.2 affichent toujours le message standard).
          </div>
        </div>
        <Switch checked={!!st.enabled} onCheckedChange={toggle} disabled={busy} data-testid="settings-phone-zero-hint" />
      </div>
      <div className="mt-2 rounded-lg px-3 py-2 text-[11px] italic" style={{ background: "var(--yalola-surface)", border: "1px dashed var(--yalola-border)" }} data-testid="settings-phone-zero-hint-preview">
        Aperçu (FR) : « {st.current_fr || st[st.enabled ? "hint" : "standard"]?.fr} »
      </div>
    </div>
  );
};
